import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface HoldingsContractSearchConditionState {
  corporateNumber: string;
  companyName: string;
  groupName: string;
  holdingsCompanyCode: string;
  timestamp: number;
}

const initialState = {} as HoldingsContractSearchConditionState;

const holdingsAffiliatedCompanySearchConditionSlice = createSlice({
  name: "holdingsAffiliatedCompanySearchCondition",
  initialState,
  reducers: {
    createSearchCondition: (
      state,
      action: PayloadAction<HoldingsContractSearchConditionState>
    ) => {
      const {
        corporateNumber,
        companyName,
        groupName,
        holdingsCompanyCode,
        timestamp,
      } = action.payload;
      state.corporateNumber = corporateNumber;
      state.companyName = companyName;
      state.groupName = groupName;
      state.holdingsCompanyCode = holdingsCompanyCode;
      state.timestamp = timestamp;
    },
  },
});

export const { createSearchCondition } =
  holdingsAffiliatedCompanySearchConditionSlice.actions;

export default holdingsAffiliatedCompanySearchConditionSlice.reducer;
